import { render } from "./footerSuperAdmin.vue?vue&type=template&id=716ea8b0&scoped=true"
import script from "./footerSuperAdmin.vue?vue&type=script&lang=js"
export * from "./footerSuperAdmin.vue?vue&type=script&lang=js"

import "./footerSuperAdmin.vue?vue&type=style&index=0&id=716ea8b0&lang=css"
import "./footerSuperAdmin.vue?vue&type=style&index=1&id=716ea8b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716ea8b0"]])

export default __exports__